import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core'
import { Router } from '@angular/router'
import { AbstractControl, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms'
import { Observable } from 'rxjs'
import { LoadingService, SessionService, UserLoginData } from '@app/core'
import { RouterQuery } from '@datorama/akita-ng-router-store'
import { TranslateService } from '@ngx-translate/core'

@Component({
  selector: 'app-login',
  // eslint-disable-next-line @angular-eslint/prefer-on-push-component-change-detection -- relies on pre-v22 default
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  standalone: false,
})
export class LoginComponent implements OnInit {
  loginForm: FormGroup<{ email: FormControl<string>; password: FormControl<string> }>

  isError = false

  isLoading$: Observable<boolean>

  routeRedirect: string

  constructor(
    private sessionService: SessionService,
    private router: Router,
    private routerQuery: RouterQuery,
    private translateService: TranslateService,
    loadingService: LoadingService,
    formBuilder: FormBuilder,
  ) {
    this.isLoading$ = loadingService.isLoading$

    this.loginForm = formBuilder.group({
      email: ['', Validators.email],
      password: [''],
    })
  }

  ngOnInit(): void {
    if (this.translateService.currentLang() !== 'en') {
      this.translateService.use('en')
    }
    this.routeRedirect = this.routerQuery.getQueryParams<string>('redirect')
  }

  get email(): AbstractControl {
    return this.loginForm.get('email')
  }

  get password(): AbstractControl {
    return this.loginForm.get('password')
  }

  setError(isError: boolean): void {
    this.isError = isError
  }

  onSubmit(loginForm): void {
    const data: UserLoginData = {
      Email: loginForm.email,
      Password: loginForm.password,
      RememberMe: true, // set to true for backend to return proper session headers
    }
    this.setError(false)

    this.sessionService.login(data).subscribe({
      next: () => {
        this.router.navigateByUrl(this.routeRedirect ?? '/')
      },
      error: () => this.setError(true),
    })
  }
}
